import { useState } from "react";

/**
 * Custom hook for project chat functionality.
 * @returns An object containing the projectChat function, data, and loading state.
 */
const useProjectChat = () => {
  const [data, setData] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_CHAT_API || "";

  /**
   * Sends a chat request to the project chat API.
   * @param username - The username of the chat user.
   * @param sourcePage - The source page of the chat request.
   * @param chatHistory - The chat history.
   * @param approach - The approach for the chat request.
   * @param indexName - The name of the search index.
   * @param promptPrefix - The prefix for the prompt.
   */
  const projectChat = async (
    username: string,
    sourcePage: string,
    chatHistory: any,
    approach: string,
    indexName: string,
    promptPrefix: string,
  ) => {
    try {
      const requestBody: any = {
        "username": username,
        "history": chatHistory,
        "approach": approach,
        "app": "knowledge_ai",
        "source_page": sourcePage,
        "search_key": process.env.REACT_APP_SEARCH_KEY || "",
        "content_field": "content",
        "search_service": process.env.REACT_APP_SEARCH_SERVICE || "",
        "search_index": indexName,
        "quick_chat": true,
        "file_name": "",
        "overrides": {
            "semantic_ranker": true,
            "semantic_captions": false,
            "top": 25,
            "prompt_default_template": promptPrefix,
            "suggest_followup_questions": true,
            "operators": "false",
            "fake_data": "false",
            "entities": [],
            "anonymization_operators": []
        }
    }

      setData(null);
      setLoading(true);
      const responseFetch = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      if (!responseFetch.ok) {
        throw new Error("Failed to fetch data");
      }
      const reader = responseFetch?.body?.pipeThrough(new TextDecoderStream()).getReader();
      while (true) {
        if(reader === undefined) break;
        const { done, value } = await reader?.read();
        if (done) break;
        setData(value)
      }
    //   setData(response);
    } catch (error) {
      console.error(error);
      throw error
    } finally {
      setLoading(false);
    }
  };

  return { projectChat, data, loading };
};

export default useProjectChat;
